import { Wordmark } from './Wordmark.js';

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--border-subtle)] bg-[var(--bg-paper-elevated)]">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
          <div>
            <Wordmark size="sm" />
            <p className="mt-3 max-w-xs font-sans text-xs leading-relaxed text-[var(--ink-tertiary)]">
              Assistente de otimização de perfil LinkedIn que não armazena seu PDF nem sua API key. Local-first,
              BYOK, transparente.
            </p>
          </div>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              Produto
            </h3>
            <ul className="mt-3 space-y-2 font-sans text-sm text-[var(--ink-secondary)]">
              <li>
                <a href="#how" className="hover:text-[var(--ink-primary)] hover:underline">
                  Como funciona
                </a>
              </li>
              <li>
                <a href="#features" className="hover:text-[var(--ink-primary)] hover:underline">
                  O que faz
                </a>
              </li>
              <li>
                <a href="#roadmap" className="hover:text-[var(--ink-primary)] hover:underline">
                  Roadmap aberto
                </a>
              </li>
              <li>
                <a
                  href="#/atualizacoes"
                  className="hover:text-[var(--ink-primary)] hover:underline"
                >
                  Atualizações
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-[var(--ink-primary)] hover:underline">
                  Dúvidas frequentes
                </a>
              </li>
              <li>
                <a href="#suggest" className="hover:text-[var(--ink-primary)] hover:underline">
                  Sugerir feature
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              Legal
            </h3>
            <ul className="mt-3 space-y-2 font-sans text-sm text-[var(--ink-secondary)]">
              <li>
                <a
                  href="#/privacidade"
                  className="hover:text-[var(--ink-primary)] hover:underline"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a
                  href="#/termos"
                  className="hover:text-[var(--ink-primary)] hover:underline"
                >
                  Termos de Uso
                </a>
              </li>
              <li>
                <a
                  href="#/cookies"
                  className="hover:text-[var(--ink-primary)] hover:underline"
                >
                  Política de Cookies
                </a>
              </li>
            </ul>
            <p className="mt-4 font-sans text-xs leading-relaxed text-[var(--ink-tertiary)]">
              Seu PDF roda em memória e some quando a sessão expira. Sua chave de IA fica só na
              sessão, nunca em banco nem em log.
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-[var(--border-subtle)] pt-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
            © {year} · SmartApply · MVP em construção pública · LGPD-compliant
          </p>
        </div>
      </div>
    </footer>
  );
}
